export const MbtiResults = [
  {
    championName: "이렐리아",
    mbti: "ISTJ",
    title: "청렴결백한 논리주의자, 협곡의 소금형",
    main: "1. 논리주의자형은 가장 다수의 사람이 속하는 성격 유형으로 인구의 대략 13%를 차지합니다. \n\n2. 이 유형의 사람들은 탑을 많이가는 편입니다. \n\n3. 논리적으로 결함이 있는 말들은 따르지 않으며, 사실에 근거한 플레이를 합니다. ",
  },
  {
    championName: "리 신",
    mbti: "ISTP",
    title: "만능 재주꾼, 백과사전형",
    main: "1. 타인을 잘 도우며 그들의 경험을 다른 이들과 공유하는 것을 좋아하기도 하는 ISTP는 특히나 그들이 아끼는 사람일수록 더욱 그러합니다. 이들이 인구의 고작 5%만이 차지합니다. \n\n2. 이 유형의 사람들은 정글을 많이가는 편입니다. \n\n3. 논리적인 판단력을 근거로 팀원들에게 오더를 내리는 사람들이 많습니다. ",
  },
  {
    championName: "브라움",
    mbti: "ISFJ",
    title: "용감한 수호자, 임금 뒷편의 권력형",
    main: "1.ISFJ 특징 유형 성격의 소유자는 조용하고 차분하며 따뜻하고 친근합니다. \n\n2. 이 유형의 사람들은 서포터를 많이가는 편입니다. \n\n3. 애정이 많고 인내력이 강하며 유틸형 서포터나 유틸형 챔피언 (ex)쉔)을자주 합니다. ",
  },
  {
    championName: "소나",
    mbti: "ISFP",
    title: "호기심 많은 예술가, 성인군자형",
    main: "1. 말없이 다정하고 온화하며 사람들에게 친절하고 상대방을 잘 알게 될 때까지 내면의 모습이 잘 보이지 않습니다. \n\n2. 이 유형의 사람들은 서포터를 많이가는 편입니다. \n\n3. 타인의 감정에 민감한편이며 채팅창에서 불의를 피하지 않습니다. ",
  },
  {
    championName: "빅토르",
    mbti: "INTJ",
    title: "용의주도한 전략가, 과학자형",
    main: "1. INTJ의 지식을 향한 갈증은 어릴 적부터 두드러지게 나타나는데, 때문에 건축가형 사람은 어릴 때 ‘책벌레’라는 소리를 자주 듣습니다. \n\n2. 이 유형의 사람들은 미드를 많이가는 편입니다. \n\n3. 남들의 말에는 개의치 않고, 본인의 플레이를 성공해 캐리하거나 실패해서 게임에서 지는등 극과극의 플레이를 자주합니다. ",
  },
  {
    championName: "신지드",
    mbti: "INTP",
    title: "논리적인 사색가, 아이디어뱅크형",
    main: "1. INTP 특징은 조용하고 과묵하며 논리와 분석으로 문제를 해결하기를 좋아합니다. \n\n2. 이 유형의 사람들은 탑을 많이가는 편입니다. \n\n3. 16가지 유형중 창의적 지능과 논리면에서 가장 뛰어나 하이리스크 하이리턴의 가능성을 항상 열어둡니다. ",
  },
  {
    championName: "아이번",
    mbti: "INFJ",
    title: "선의의 옹호자, 예언자형",
    main: "1. INFJ 특징은 인내심이 많고 통찰력과 직관력이 뛰어나며 화합을 추구합니다. \n\n2. 이 유형의 사람들은 정글을 많이가는 편입니다. \n\n3. 말없이 플레이로 보여줘 팀원들에게 영향을 미치며, 게임속 채팅은 신경을 잘 안쓰는 편입니다. ",
  },
  {
    championName: "아무무",
    mbti: "INFP",
    title: "열정적인 중재자, 잔 다르크형",
    main: "1. 중재자형 사람은 최악의 상황이나 악한 사람에게서도 좋은 면만을 바라보며 긍정적이고 더 나은 상황을 만들고자 노력하는 진정한 이상주의자입니다. \n\n2. 이 유형의 사람들은 정글을 많이가는 편입니다. \n\n3. 이 유형의 사람들은 조금 소심해 보일수 있으나, 마음이 잘맞는 팀원이나 듀오와 함께라면 200%의 힘을 발휘합니다. ",
  },
  {
    championName: "사미라",
    mbti: "ESTJ",
    title: "엄격한 관리자, 사업가형",
    main: "1. 관리자형 유형은 그들 생각에 반추하여 무엇이 옳고 그른지를 따져 사회나 가족을 하나로 단결시키기 위해 사회적으로 받아들여지는 통념이나 전통 등 필요한 질서를 정립하는 데 이바지하는 대표적인 유형입니다. \n\n2. 이 유형의 사람들은 원딜을 많이가는 편입니다. \n\n3. 위험한 플레이는 최대한 배제하고, 안정성 있는 딜링을 합니다. 기복없는 플레이를 하려고 노력합니다. ",
  },
  {
    championName: "이즈리얼",
    mbti: "ESTP",
    title: "모험을 즐기는 사업가, 수완좋은 활동가형",
    main: "1. ESTP 특징은 주변에 지대한 영향을 주는 사업가형 사람은 여러 사람이 모인 행사에서 이 자리 저 자리 휙휙 옮겨 다니는 무리 중에서 어렵지 않게 찾아볼 수 있습니다.\n\n2. 이 유형의 사람들은 원딜을 많이가는 편입니다. \n\n3. 본인 중심의 플레이를 원하며, 케어를 많이 받으려고 합니다. 팀원간의 갈등이 종종 있으나 리턴이 확실한 편입니다. ",
  },
  {
    championName: "럭스",
    mbti: "ESFJ",
    title: "사교적인 외교관, 친선도모형",
    main: "1. ESFJ 유형인 사교형 사람을 한마디로 정의 내리기는 어렵지만, 간단히 표현하자면 이들은 ‘인기쟁이’입니다.\n\n2. 이 유형의 사람들은 서포터를 많이가는 편입니다. \n\n3. 이들은 팀 분위기를 좌지우지하며 채팅으로나 플레이로나 팀원간의 화합을 중요시합니다. 게임을 지더라도 채팅으로 얼굴 붉히는 일이 거의 없습니다. ",
  },
  {
    championName: "나르",
    mbti: "ESFP",
    title: "자유로운 영혼의 연예인, 사교적인 유형",
    main: "1. ESFP 유형으로 갑자기 흥얼거리며 즉흥적으로 춤을 추기 시작하는 누군가가 있다면 이는 연예인형의 사람일 가능성이 큽니다.\n\n2. 이 유형의 사람들은 탑을 많이가는 편입니다. \n\n3. 모든 유형중 채팅을 가장 많이하는 유형일 확률이 높고, 게임의 승리는 조금 미뤄두고 본인의 재미를 추구합니다. ",
  },
  {
    championName: "레오나",
    mbti: "ENTJ",
    title: "대담한 통솔자, 지도자형",
    main: `1. 이 유형에 속하는 사람은 넘치는 카리스마와 자신감으로 공통의 목표 실현을 위해 다른 이들을 이끌고 진두지휘합니다.\n\n2. 이 유형의 사람들은 서포터를 많이가는 편입니다.\n\n3. 게임 플레이중 본인화면보다는 다른 화면을 읽으며 게임을 분석하고 메인오더를 내립니다. 이 유형의 사람들의 오더는 이성적일 확률이 매우 높으므로 오더를 듣는다면 열에 아홉은 성공합니다. `,
  },
  {
    championName: "제리",
    mbti: "ENTP",
    title: "뜨거운 논쟁을 즐기는 변론가, 발명가형",
    main: "1. 변론가형 사람은 타인이 믿는 이념이나 논쟁에 반향을 일으킴으로써 군중을 선동하는 일명 선의의 비판자입니다.\n\n2. 이 유형의 사람들은 원딜을 많이가는 편입니다. \n\n3. 채팅으로 불만을 표하는등 팀원간의 갈등이 어느정도 있지만, 창의적인 플레이로 다양한 변수를 창출합니다. ",
  },
  {
    championName: "세라핀",
    mbti: "ENFJ",
    title: "정의로운 사회운동가, 언변능숙형",
    main: "1. 상당히 이타적이고 민첩하고 인화를 중요시하며 참을성이 많으며, 다른 사람들의 생각이나 의견에 진지한 관심을 가지고 공동선을 위하여 다른 사람의 의견에 대체로 동의합니다.\n\n2. 이 유형의 사람들은 서포터를 많이가는 편입니다. \n\n3. 본인의 의사보다는 다른사람의 의사를 존중해주는 편이고, 오더를 따르는 편입니다. 팀원들과의 갈등이 거의 없는편입니다. ",
  },
  {
    championName: "조이",
    mbti: "ENFP",
    title: "재기발랄한 활동가, 스파크형",
    main: "1. 종종 분위기 메이커 역할을 하기도 하는 이들은 단순한 인생의 즐거움이나 그때그때 상황에서 주는 일시적인 만족이 아닌 타인과 사회적, 정서적으로 깊은 유대 관계를 맺음으로써 행복을 느낍니다.\n\n2. 이 유형의 사람들은 미드를 많이가는 편입니다. \n\n3. 에너지가 넘치며 팀원으로 있을때는 든든하고, 상대편으로 있을때는 까다로운 유형입니다. 보통 로밍형 챔프를 잘 다루고 팀원과의 사이를 좋게 이끌어갑니다. ",
  },
];
